<div class="past-performances-container" *ngIf="!loading && !error && pastPerformances.length > 0">
  <h2 class="section-title" translate="shared.labels.pastEvents"></h2>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="40" color="primary"></mat-spinner>
  </div>

  <div *ngIf="error" class="error-container">
    <p class="error-message">{{ error }}</p>
  </div>

  <!--
  <div *ngIf="!loading && !error && pastPerformances.length === 0" class="empty-container">
    <p class="empty-message">{{'shared.labels.noPastEvent' | translate}}</p>
  </div>
  -->

  <div *ngIf="!loading && !error && pastPerformances.length > 0" class="performances-list">
    <div class="performance-item" *ngFor="let performance of pastPerformances">
      <div class="date-box">
        <div class="date-number">{{ getDayFromTimestamp(performance.performanceDate) }}</div>
        <div class="date-month">{{ getMonthNameFromTimestamp(performance.performanceDate) }}</div>
        <!-- <div class="date-day">{{ getDayNameFromTimestamp(performance.performanceDate) }}</div> -->
      </div>
      <div class="event-details">
        <div class="event-name">{{ performance.eventName }}</div>
        <div class="event-location">
          <mat-icon>location_on</mat-icon>
          <span>{{ performance.venueName | shorten: 25}}</span>
          <!-- <div class="event-time">
            <mat-icon>schedule</mat-icon>
            <span>{{ getTime(performance.performanceDate) }}</span>
          </div> -->
        </div>
      </div>

    </div>
  </div>

  <div *ngIf="!loading && !error && hasMoreItems" class="see-more-container">
    <button mat-stroked-button color="primary" class="see-more-btn" (click)="showMoreItems()" translate="shared.labels.showMore"></button>
  </div>
</div>
